import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import CourseList from '../components/pages/CourseList.vue'
import CourseDetail from '../components/pages/CourseDetail.vue'
import CoursePurchase from '../components/pages/CoursePurchase.vue'
import CourseMyList from '../components/pages/CourseMyList.vue'
import CourseMyDetail from '../components/pages/CourseMyDetail.vue'
import ExamTestMain from '../components/pages/ExamTestMain.vue'
import ExamList from '../components/pages/ExamList.vue'
import ExamRecommendationList from '../components/pages/ExamRecommendationList.vue'
import ExamDetail from '../components/pages/ExamDetail.vue'
import ExamPurchase from '../components/pages/ExamPurchase.vue'
import ExamMyList from '../components/pages/ExamMyList.vue'
import ExamShow from '../components/pages/ExamTestShow.vue'
import ExamTestQuestionList from '../components/pages/ExamTestQuestionList.vue'
import ExamResult from '../components/pages/ExamResult.vue'
import ExamResultQuestionList from '../components/pages/ExamResultQuestionList.vue'
import ExamResultMain from '../components/pages/ExamResultMain.vue'
import MyProfileComponent from '../components/pages/MyProfile.vue'
import NotificationList from '../components/pages/NotificationList.vue'
import ActivityList from '../components/pages/ActivityList.vue'
import SubscriptionList from '../components/pages/SubscriptionList.vue'
import SubscriptionDetail from '../components/pages/SubscriptionDetail.vue'
import CoursePurchaseDetail from '../components/pages/CoursePurchaseDetail.vue'
import UserQuestionListPage from '../components/pages/UserQuestionListPage.vue'
import UserAnswerQuestionMyList from '../components/pages/UserAnswerQuestionMyList.vue'
import UserQuestionMyList from '../components/pages/UserQuestionMyList.vue'
import UserQuestionDetail from '../components/pages/UserQuestionDetail.vue'
import NotFound from '../components/pages/NotFound.vue'
import UserGoalList from '../components/pages/UserGoalList.vue'
import UserGoalDetail from '../components/pages/UserGoalDetail.vue'
import InforList from '../components/pages/InforList.vue'
import InforDetail from '../components/pages/InforDetail.vue'
import InquiryList from '../components/pages/InquiryList.vue'
import InquiryDetail from '../components/pages/InquiryDetail.vue'
import Home from '../components/pages/Home.vue'
import OnBoarding from '../components/pages/OnBoarding.vue'
import { setupExamRouterHistories } from '../utils/setup_exam_router'
import { rememberExamGoal, forgetExamGoal } from '../utils/exam_goal_context'
import ChangePlanPlanConfirm from '../components/pages/subscription/change_plan/PlanConfirm.vue'
import ChangePlanPaymentConfirm from '../components/pages/subscription/change_plan/PaymentConfirm.vue'
import ChangePlanCompletion from '../components/pages/subscription/change_plan/Completion.vue'
import MyProfileUserAccountDeletion from '../components/pages/MyProfileUserAccountDeletion.vue'
import Meeting from '../components/pages/Meeting.vue'

export const ROUTER_NAME = {
  HOME: 'home',
  ON_BOARDING: 'on-boarding',
  QUESTION: 'question',
  EXAM_SHOW: 'exam-show',
  EXAM_LIST: 'exam-list',
  EXAM_RECOMMENDATION_LIST: 'exam-recommendation-list',
  MY_EXAM_LIST: 'my-exam-list',
  EXAM_DASHBOARD: 'exam-dashboard',
  EXAM_DETAIL: 'exam-detail',
  EXAM_PURCHASE: 'exam-purchase',
  QUESTION_HEADER: 'question-header',
  EXAM_QUESTION_LIST: 'exam-question-list',
  EXAM_RESULT: 'exam-result',
  EXAM_RESULT_QUESTION_LIST: 'exam-result-question-list',
  ANSWER_RESULT_DETAIL: 'answer-result-detail',
  MYPROFILE: 'myprofile',
  NOTIFICATION: 'notification',
  PREMIUM_SERVICE: 'premium-service',
  SUBSCRIPTION: 'subscription',
  SUBSCRIPTION_DETAIL: 'subscription-detail',
  COURSES: 'courses',
  COURSE_DETAIL: 'course-detail',
  COURSE_PURCHASE: 'course-purchase',
  MY_COURSES: 'my-courses',
  MY_COURSE_DETAIL: 'my-course-detail',
  NOT_FOUND: 'not-found',
  USER_QUESTION_LIST: 'user-question-list',
  MY_USER_QUESTION_LIST: 'my-user-question-list',
  MY_ANSWER_QUESTION_LIST: 'my-answer-question-list',
  USER_QUESTION_DETAIL: 'user-question-detail',
  DASHBOARD: 'dashboard',
  USER_GOAL_LIST: 'user-goal-list',
  USER_GOAL_DETAIL: 'user-goal-detail',
  USER_GOAL_DETAIL_COURSE: 'user-goal-detail-course',
  USER_GOAL_DETAIL_EXAM: 'user-goal-detail-exam',
  INFOR_DETAIL: 'infor-detail',
  INFOR_LIST: 'infor-list',
  ACTIVITY_LIST: 'activity-list',
  INQUIRY_DETAIL: 'inquiry-detail',
  INQUIRY_LIST: 'inquiry-list',
  COURSE_PURCHASE_DETAIL: 'course-purchase-detail',
  SUBSCRIPTION_CHANGE_PLAN: 'subscription-change-plan-confirm',
  SUBSCRIPTION_CHANGE_PLAN_PAYMENT_CONFIRM: 'subscription-change-plan-payment-confirm',
  SUBSCRIPTION_CHANGE_PLAN_COMPLETION: 'subscription-change-plan-completion',
  MYPROFILE_USER_ACCOUNT_DELETION: 'myprofile-user-account-deletion',
  MEETING: 'meeting',
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/classroom/'
  },
  {
    path: '/classroom/',
    component: Home,
    name: ROUTER_NAME.HOME,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'ダッシュボード'
    }
  },
  {
    path: '/classroom/on-boarding',
    component: OnBoarding,
    name: ROUTER_NAME.ON_BOARDING,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'オンボーディング',
      onboardingMode: true
    }
  },
  {
    path: '/classroom/my-exams/',
    component: ExamMyList,
    name: ROUTER_NAME.MY_EXAM_LIST,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'マイテスト'
    }
  },
  {
    path: '/classroom/exam-list/',
    component: ExamList,
    name: ROUTER_NAME.EXAM_LIST,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'テスト一覧'
    }
  },
  {
    path: '/classroom/exam-recommendation/',
    component: ExamRecommendationList,
    name: ROUTER_NAME.EXAM_RECOMMENDATION_LIST,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'おすすめテスト一覧'
    }
  },
  {
    path: '/classroom/exam-list/:examId/',
    component: ExamDetail,
    name: ROUTER_NAME.EXAM_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'テスト詳細'
    }
  },
  {
    path: '/classroom/exam-list/:examId/purchase/',
    component: ExamPurchase,
    name: ROUTER_NAME.EXAM_PURCHASE,
    meta: {
      transitionName: 'slide',
      index: 0,
      title: 'テスト購入'
    }
  },
  {
    path: '/classroom/my-exams/:examId/',
    component: ExamShow,
    name: ROUTER_NAME.EXAM_SHOW,
    meta: {
      transitionName: 'slide',
      index: 1,
      title: 'テスト詳細',
      hideDefaultHeader: true
    }
  },
  {
    path: '/classroom/my-exams/:examId/questions/:questionId/',
    component: ExamTestMain,
    name: ROUTER_NAME.QUESTION,
    meta: {
      transitionName: 'slide',
      index: 1,
      title: 'テスト',
      hideDefaultHeader: true
    }
  },
  {
    path: '/classroom/my-exams/:examId/question-list/',
    component: ExamTestQuestionList,
    name: ROUTER_NAME.EXAM_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 2,
      title: '問題一覧'
    }
  },
  {
    path: '/classroom/my-exams/:examId/result/',
    component: ExamResult,
    name: ROUTER_NAME.EXAM_RESULT,
    meta: {
      transitionName: 'slide',
      index: 3,
      title: 'テスト結果'
    }
  },
  {
    path: '/classroom/my-exams/:examId/result/question-list',
    component: ExamResultQuestionList,
    name: ROUTER_NAME.EXAM_RESULT_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 3,
      title: '問題一覧'
    }
  },
  {
    path: '/classroom/my-exams/:examId/result/questions/:questionId/',
    component: ExamResultMain,
    name: ROUTER_NAME.ANSWER_RESULT_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: '回答'
    }
  },
  {
    path: '/classroom/courses/',
    component: CourseList,
    name: ROUTER_NAME.COURSES,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'コース一覧'
    }
  },
  {
    path: '/classroom/courses/:courseId/',
    component: CourseDetail,
    name: ROUTER_NAME.COURSE_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'コース詳細'
    }
  },
  {
    path: '/classroom/user-goals/:userGoalId/courses/:courseId/',
    component: CourseDetail,
    name: ROUTER_NAME.USER_GOAL_DETAIL_COURSE,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'コース詳細'
    }
  },
  {
    path: '/classroom/user-goals/:userGoalId/exam-list/:examId/',
    component: ExamDetail,
    name: ROUTER_NAME.USER_GOAL_DETAIL_EXAM,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'テスト詳細'
    }
  },
  {
    path: '/classroom/courses/:courseId/purchase/',
    component: CoursePurchase,
    name: ROUTER_NAME.COURSE_PURCHASE,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'コース購入'
    }
  },
  {
    path: '/classroom/my-courses/',
    component: CourseMyList,
    name: ROUTER_NAME.MY_COURSES,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'マイコース一覧'
    }
  },
  {
    path: '/classroom/my-courses/:courseId/',
    component: CourseMyDetail,
    name: ROUTER_NAME.MY_COURSE_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 5,
      title: 'コース詳細',
      hideDefaultMenu: true,
      hideDefaultHeader: true,
      hideBreadcrumb: true
    }
  },
  {
    path: '/classroom/myprofile/',
    component: MyProfileComponent,
    name: ROUTER_NAME.MYPROFILE,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'マイプロフィール'
    }
  },
  {
    path: '/classroom/myprofile/user-account-deletion',
    component: MyProfileUserAccountDeletion,
    name: ROUTER_NAME.MYPROFILE_USER_ACCOUNT_DELETION,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'アカウント削除'
    }
  },
  {
    path: '/classroom/notifications/',
    component: NotificationList,
    name: ROUTER_NAME.NOTIFICATION,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'お知らせ'
    }
  },
  {
    path: '/classroom/activities/',
    component: ActivityList,
    name: ROUTER_NAME.ACTIVITY_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'アクティビティ'
    }
  },
  {
    path: '/classroom/subscription/',
    component: SubscriptionList,
    name: ROUTER_NAME.SUBSCRIPTION,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '購入済み'
    }
  },
  {
    path: '/classroom/subscription/:subscriptionId',
    component: SubscriptionDetail,
    name: ROUTER_NAME.SUBSCRIPTION_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '購入済み'
    }
  },
  {
    path: '/classroom/course_purchases/:coursePurchaseId',
    component: CoursePurchaseDetail,
    name: ROUTER_NAME.COURSE_PURCHASE_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '購入済み'
    }
  },
  {
    path: '/classroom/not-found/',
    component: NotFound,
    name: ROUTER_NAME.NOT_FOUND,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'Not Found'
    }
  },
  {
    path: '/classroom/questions/',
    component: UserQuestionListPage,
    name: ROUTER_NAME.USER_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '質問一覧'
    }
  },
  {
    path: '/classroom/my-questions/',
    component: UserQuestionMyList,
    name: ROUTER_NAME.MY_USER_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'マイ質問'
    }
  },
  {
    path: '/classroom/my-answer-questions/',
    component: UserAnswerQuestionMyList,
    name: ROUTER_NAME.MY_ANSWER_QUESTION_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'アンサーした質問'
    }
  },
  {
    path: '/classroom/questions/:questionId/',
    component: UserQuestionDetail,
    name: ROUTER_NAME.USER_QUESTION_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '質問詳細'
    }
  },
  {
    path: '/classroom/user-goals/',
    component: UserGoalList,
    name: ROUTER_NAME.USER_GOAL_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'ゴール一覧'
    }
  },
  {
    path: '/classroom/user-goals/:userGoalId/',
    component: UserGoalDetail,
    name: ROUTER_NAME.USER_GOAL_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'ゴール詳細'
    }
  },
  {
    path: '/classroom/infors/:inforId/',
    component: InforDetail,
    name: ROUTER_NAME.INFOR_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'お知らせ'
    }
  },
  {
    path: '/classroom/infors/',
    component: InforList,
    name: ROUTER_NAME.INFOR_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: 'お知らせ一覧'
    }
  },
  {
    path: '/classroom/inquiries/',
    component: InquiryList,
    name: ROUTER_NAME.INQUIRY_LIST,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '問い合わせ一覧'
    }
  },
  {
    path: '/classroom/inquiries/:inquiryId',
    component: InquiryDetail,
    name: ROUTER_NAME.INQUIRY_DETAIL,
    meta: {
      transitionName: 'slide',
      index: 6,
      title: '問い合わせ詳細'
    }
  },
  {
    path: '/classroom/subscription/:subscriptionId/change-plan/plan-confirm',
    component: ChangePlanPlanConfirm,
    name: ROUTER_NAME.SUBSCRIPTION_CHANGE_PLAN,
  },
  {
    path: '/classroom/subscription/:subscriptionId/change-plan/payment-confirm',
    component: ChangePlanPaymentConfirm,
    name: ROUTER_NAME.SUBSCRIPTION_CHANGE_PLAN_PAYMENT_CONFIRM,
  },
  {
    path: '/classroom/subscription/:subscriptionId/change-plan/completion',
    component: ChangePlanCompletion,
    name: ROUTER_NAME.SUBSCRIPTION_CHANGE_PLAN_COMPLETION,
  },
  {
    path: '/classroom/appointment',
    component: Meeting,
    name: ROUTER_NAME.MEETING,
  }
]

export const vueRouter = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { left: 0, top: 0 }
  }
})

// ゴールから開いたテストかどうかを覚える（受験中・結果の画面の「戻る」をゴールへ向けるため）。テスト一覧から開いたら忘れる
vueRouter.beforeEach((to) => {
  const examId = to.params.examId as string | undefined
  if (!examId) return
  if (to.name === ROUTER_NAME.USER_GOAL_DETAIL_EXAM && to.params.userGoalId) {
    rememberExamGoal(examId, to.params.userGoalId as string)
  } else if (to.name === ROUTER_NAME.EXAM_DETAIL) {
    forgetExamGoal(examId)
  }
})

setupExamRouterHistories(
  vueRouter,
  [
    ROUTER_NAME.MY_EXAM_LIST,
    ROUTER_NAME.DASHBOARD,
    ROUTER_NAME.EXAM_DASHBOARD,
    ROUTER_NAME.EXAM_SHOW,
    ROUTER_NAME.EXAM_RESULT
  ]
)